<template>
    <div>
  
      <el-row style="margin-bottom:10px;">
        <el-col :span="18" class='flex'>
          <el-input
            v-model="getQuestionTopicClassList_data.qtcName"
            placeholder="请输入题目类型名"
            clearable
            size='small'
            style="max-width:380px;"/>
          <el-button
            v-click.getQuestionTopicClassList
            type="primary"
            icon='el-icon-search'
            size='small'
            style='margin-left:10px;'
          >搜索
          </el-button>
        </el-col>
        <el-col :span="6" >
          <el-button
            v-if='addQuestionTopicClass'
            @click=" $form('addQuestionTopicClass') "
            size='small'
            type="primary"
            style="float:right"
            icon='el-icon-circle-plus'
          >添加题目类型
          </el-button>
        </el-col>
      </el-row>
  
      <mytable
        :tableColums='tableColums_getQuestionTopicClassList'
        api='getQuestionTopicClassList'
        updateapi='updateQuestionTopicClass'
        :height="H-165" >
      </mytable> 
  
      <myform
        :viewobj='{
          addQuestionTopicClass:    [ "新增题目类型信息", "el-icon-circle-plus" ],
          updateQuestionTopicClass: [ "修改题目类型信息", "el-icon-edit-outline"],
          $succeed$: getQuestionTopicClassList
        }'
        @close='$form("addQuestionTopicClass","reset")' >
        <!-- <hide slot='vtId' /> -->
      </myform>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        vtId: null,
  
        tableColums_getQuestionTopicClassList: {
          $selection: false,
  
          qtcName: '题目名称',
  
  
  
          // ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],
  
          $operation: [
            '操作', 200,
            this.updateQuestionTopicClass && `@text: 编辑#success
             @click: $form("updateQuestionTopicClass",$row)
            `,
            this.deleteAjMobileCard && `@text: 删除#danger
             @click: _confirm('确定要删除该题目类型吗?')
                     .trigger('deleteAjMobileCard',{qtcIds:$row.qtcId})
                     .trigger('getQuestionTopicClassList')
            `,
          ],
  
        },
  
      };
    },
  
    watch: {
      
    },
  
    methods: {},
  
    created() {
      this.getQuestionTopicClassList();
    }
  };
  </script>
  
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/views/paper/topicType.vue